export default "__VITE_ASSET__Dxs0MOZ9__"